namespace GeniuzPOS.CustomReport {
    export interface ReportCusStockOnHandForm {
    }

    export class ReportCusStockOnHandForm extends Serenity.PrefixedContext {
        static formKey = 'CustomReport.ReportCusStockOnHand';
    }
}
